module.exports = __webpack_public_path__ + "media/images/iconSquadBet__check-d30bb157efb52cc49e00b2b3d91bcf31.png";